<template>
  <layout title="Verstuurde Pogingen">
    <main class="relative z-0 flex-1 overflow-y-auto focus:outline-none" tabindex="0">
      <!-- Page title & actions -->
      <div class="px-4 py-4 border-b border-gray-200 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <div class="flex-1 min-w-0">
          <h1 class="text-lg font-medium leading-6 text-gray-900 sm:truncate">
            Verzonden
          </h1>
        </div>
        <div class="flex mt-4 sm:mt-0 sm:ml-4">
          <span class="rounded-md shadow-sm order-0 sm:order-1 sm:ml-3">
          </span>
        </div>
      </div>

      <div class="hidden sm:block">
        <div class="inline-block min-w-full align-middle border-b border-gray-200">
          <table class="min-w-full">
            <thead>
              <tr class="border-t border-gray-200">
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  <span class="lg:pl-2">Deelnemer</span>
                </th>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  <span class="lg:pl-2">Naar</span>
                </th>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  Organisatie
                </th>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  Template
                </th>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  Verstuurd op
                </th>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  Aangekomen op
                </th>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  Geopend op
                </th>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  Geklikt op
                </th>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  Bestand geopend op
                </th>
                <th v-if="is('BCSA')"
                  class="py-3 pr-6 text-xs font-medium leading-4 tracking-wider text-right text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-100">
              <tr class="hover:bg-gray-100" v-for="attempt in attempts.data" :key="attempt.id">
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-900 whitespace-nowrap max-w-0">
                  <div class="flex items-center space-x-3 lg:pl-2">
                    <div class="flex-shrink-0 w-2.5 h-2.5 rounded-full bg-green-600"></div>
                    <a href="#" class="truncate hover:text-gray-600">
                      {{ attempt.attendee.name }}
                    </a>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  <div class="flex items-center space-x-2">
                    <span class="flex-shrink-0 text-xs font-medium leading-5">{{ attempt.attendee.email }}</span>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  <div class="flex items-center space-x-2">
                    <span class="flex-shrink-0 text-xs font-medium leading-5">{{ attempt.organisation_name }}</span>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  <div class="flex items-center space-x-2">
                    <span class="flex-shrink-0 text-xs font-medium leading-5">{{ attempt.template_name }} ({{
                        attempt.template_difficulty
                    }})</span>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  <div class="flex items-center space-x-2">
                    <span class="flex-shrink-0 text-xs font-medium leading-5">{{ attempt.send_at }}</span>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  <div class="flex items-center space-x-2">
                    <span :class="{ 'bg-green-400 rounded p-1 px-2 text-white': attempt.delivered_at != null }"
                      class="flex-shrink-0 text-xs font-medium leading-5">{{ attempt.delivered_at || '-' }}</span>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  <div class="flex items-center space-x-2">
                    <span :class="{ 'bg-yellow-400 rounded p-1 px-2 text-white': attempt.openend_at != null }"
                      class="flex-shrink-0 text-xs font-medium leading-5">{{ attempt.openend_at || '-' }}</span>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  <div class="flex items-center space-x-2">
                    <span :class="{ 'bg-red-400 rounded p-1 px-2 text-white': attempt.clicked_at != null }"
                      class="flex-shrink-0 text-xs font-medium leading-5">{{ attempt.clicked_at || '-' }}</span>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  <div class="flex items-center space-x-2">
                    <span :class="{ 'bg-red-400 rounded p-1 px-2 text-white': attempt.clicked_at != null }"
                      class="flex-shrink-0 text-xs font-medium leading-5">{{ attempt.attachment_opened_at || '-' }}</span>
                  </div>
                </td>
                <td v-if="is('BCSA')" class="pr-6">
                  <div class="relative flex items-center justify-end">
                    <button @click="clickOptionDropdown(attempt.id)" id="project-options-menu-0" aria-has-popup="true"
                      type="button"
                      class="inline-flex items-center justify-center w-8 h-8 text-gray-400 transition duration-150 ease-in-out bg-transparent rounded-full hover:text-gray-500 focus:outline-none focus:text-gray-500 focus:bg-gray-100">
                      <!-- Heroicon name: dots-vertical -->
                      <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path
                          d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                      </svg>
                    </button>

                    <div v-if="optionDropdown(attempt.id)"
                      class="absolute top-0 w-48 mx-3 mt-1 origin-top-right rounded-md shadow-lg right-7">
                      <div class="z-10 bg-white rounded-md shadow-xs" role="menu" aria-orientation="vertical"
                        aria-labelledby="project-options-menu-0">
                        <a @click="checkOpen(attempt)"
                          class="flex items-center px-4 py-2 text-sm leading-5 text-gray-700 group hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                          role="menuitem">
                          <!-- Heroicon name: pencil-alt -->
                          <svg class="w-5 h-5 mr-3 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                            fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                            </path>
                          </svg>
                          Check opening
                        </a>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <!-- More project rows... -->
            </tbody>
          </table>
        </div>
      </div>

      <Pagination :links="attempts.links" :meta="attempts.meta" class="" />

    </main>
  </layout>
</template>

<script>
import Layout from '@/Shared/Layout'
import Pagination from '../../Shared/Pagination.vue';

export default {
  props: {
    attempts: Object
  },
  data: () => ({
    optionDropdownId: null,
  }),
  methods: {
    optionDropdown(id) {
      return this.optionDropdownId === id;
    },
    clickOptionDropdown(id) {
      if (this.optionDropdownId === id) {
        this.optionDropdownId = null;
      }
      else {
        this.optionDropdownId = id;
      }
    },
    checkOpen(attempt) {
      window.open(attempt.links.check, "_blank");
      this.optionDropdownId = null;
    }
  },
  components: { Pagination, Layout }
}

</script>
